const Memcached = require('memcached');
const snappy = require('snappy');

function memcachedCacheService(conf) {
    const config = conf || {};
    const verbose = config.verbose || false;
    const defaultExpiration = config.defaultExpiration || 900;
    const backgroundRefreshIntervalCheck = (typeof config.backgroundRefreshIntervalCheck === 'boolean') ? config.backgroundRefreshIntervalCheck : true;
    const backgroundRefreshInterval = config.backgroundRefreshInterval || 60000;
    const backgroundRefreshMinTtl = config.backgroundRefreshMinTtl || 70000;
    const memcachedConfig = config.memcached;

    let refreshKeys = {};
    let backgroundRefreshEnabled = false;

    const memcached = new Memcached(memcachedConfig.servers, memcachedConfig);

    if (verbose) console.log('memcachedCacheService config', { defaultExpiration });

    /**
     * Initialize background refresh
     */
    function backgroundRefreshInit() {
        if (!backgroundRefreshEnabled) {
            backgroundRefreshEnabled = true;
            if (backgroundRefreshIntervalCheck) {
                if (backgroundRefreshInterval > backgroundRefreshMinTtl) {
                    throw new Error('BACKGROUND_REFRESH_INTERVAL_EXCEPTION:' +
                        ' backgroundRefreshInterval cannot be greater than backgroundRefreshMinTtl.');
                }
            }
            setInterval(function() {
                backgroundRefresh();
            }, backgroundRefreshInterval);
        }
    }

    /**
     * Refreshes all keys that were set with a refresh function
     */
    function backgroundRefresh() {
        if (verbose) console.log('memcachedCacheService.backgroundRefresh');

        Object.keys(refreshKeys).forEach((key) => {
            var data = refreshKeys[key];
            if (data.expiration - Date.now() < backgroundRefreshMinTtl) {
                data.refresh (key, function (err, response) {
                    if (!err) {
                        if (verbose) console.log('memcachedCacheService.backgroundRefresh', { key });
                        set(key, response, data.lifeSpan, data.refresh, () => {});
                    }
                });
            }
        });
    }

    function get(key, callback = () => {}) {
        return memcached.get(key, (err, data) => {
            if (verbose) console.log('memcachedCacheService.get', { key });
            if (err) {
                console.error(err);
                callback(err);
            } else if (!data){
                callback(new Error('No data returned from memcached'));
            } else {
                snappy.uncompress(data, {asBuffer: false}, (snappyErr, original) => {
                    if (snappyErr){
                        callback(snappyErr);
                        return;
                    }
                    let resp;
                    try {
                        resp = JSON.parse(original);
                    } catch (parseError) {
                        resp = original;
                    }
                    callback(snappyErr, resp);
                });
            }
        });
    }

   function set(key, value) {
       snappy.compress(JSON.stringify(value), (compressionErr, compressedValue) => {
           const expiration = (arguments[2] || null) || defaultExpiration;
           const refresh = (arguments.length == 5) ? arguments[3] : null;
           const callback = ((arguments.length == 5) ? arguments[4] : arguments[3]) || (() => {});
           return memcached.set(key, compressedValue, expiration, (err) => {
               if (verbose) console.log('memcachedCacheService.set', { key, compressedValue, expiration, refresh });
               if (err) console.error(key, err);
               callback(err);

               if (refresh && !err) {
                   const exp = (expiration * 1000) + Date.now();
                   refreshKeys[key] = { expiration: exp, lifeSpan: expiration, refresh: refresh };
                   backgroundRefreshInit();
               }
           });
       });
    }

    return {
        db: memcached,
        type: 'memcached',
        verbose,
        defaultExpiration,
        get,
        mget: memcached.getMulti,
        set,
        mset: function(obj, [expiration], [callback]) {
            // TODO: implement this.
        },
        del: (keys, callback = () => {}) => {
            if (verbose) console.log('memcachedCacheService.del', { keys });

            if (typeof keys === 'object') {
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    memcached.del(key, callback);
                    delete refreshKeys[key];
                }
            } else {
                memcached.del(keys, callback);
                delete refreshKeys[keys];
            }


            delete refreshKeys[key];
        },
        flush: (callback = () => {}) => {
            if (verbose) console.log('memcachedCacheService.flush');
            refreshKeys = {};
            memcached.flush(callback);
        }
    }
}

module.exports = memcachedCacheService;



// WEBPACK FOOTER //
// ./app/lib/api/cache/memcachedCacheService.js